customElements.get("ajax-modal") || customElements.define("ajax-modal", class extends HTMLElement {
  buttons=this.querySelectorAll("a");
  url=this.dataset.url;
  view=this.dataset.view;
  id=this.dataset.id || "AjaxModal-" + (this.url ? this.url.replace(/\W/g, "") : Math.random().toString(36).substring(2, 15));
  constructor() {
    super();
  }
  loadStart() {
    this.classList.add("opacity-50", "cursor-wait");
  }
  loadEnd() {
    this.classList.remove("opacity-50", "cursor-wait");
  }
  load() {
    this.loadStart();
    let t = new URL(this.url, `${location.protocol}//${location.host}`);
    this.view && t.searchParams.set("view", this.view), this.id && document.getElementById(this.id) ? setTimeout((() => {
      const t = document.getElementById(this.id);
      (t.querySelector("summary") || t).click(), t.setAttribute("open", "open"), this.loadEnd();
    })) : fetch(t).then((t => {
      if (t.ok) return t.text();
      throw new Error(t.message);
    })).then((t => {
      if (!(t.length > 0)) throw new Error("Empty response");
      {
        const e = (new DOMParser).parseFromString(t, "text/html");
        (e.body.querySelector("details") || e.body.firstElementChild || e.body).id = this.id, 
        document.body.append(e.body.firstElementChild);
      }
    })).catch((t => {
      console.warn(t), location.href = this.url;
    })).finally((() => {
      this.loadEnd();
    }));
  }
  connectedCallback() {
    this.url && this.buttons.forEach((t => {
      t.addEventListener("click", (e => {
        e.preventDefault(), window.index = t.dataset.index || 0, this.load();
      }));
    }));
  }
});